module.exports = __webpack_public_path__ + "img/nowruz.ed57ba3.png";